import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import {
  postJwtLogin,
  postJwtLogout,
} from "../../../helpers/fakebackend_helper";
import { axiosApi } from "helpers/api_helper";
import secureLocalStorage from "react-secure-storage";
import { hasRolePermission } from "helpers/rolebased_helper";

export function clearLocalStorage() {
  secureLocalStorage.removeItem("token");
  secureLocalStorage.removeItem("email");
  secureLocalStorage.removeItem("refreshToken");
  secureLocalStorage.removeItem("authUser");

  delete axiosApi.defaults.headers.common["Authorization"];
  delete axiosApi.defaults.headers.common["x-refresh-token"];
  delete axiosApi.defaults.headers.common["email"];
}

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });

      const token = response.token;
      const refreshToken = response.refreshToken;
      const email = response.email;
      const employeeId = response.employeeId;

      axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axiosApi.defaults.headers.common[
        "x-refresh-token"
      ] = `Bearer ${refreshToken}`;
      axiosApi.defaults.headers.common["email"] = email;

      secureLocalStorage.setItem("authUser", JSON.stringify(response));
      secureLocalStorage.setItem("token", JSON.stringify(token));
      secureLocalStorage.setItem("refreshToken", JSON.stringify(refreshToken));
      secureLocalStorage.setItem("email", JSON.stringify(email));
      secureLocalStorage.setItem("employeeId", JSON.stringify(employeeId));

      yield put(loginSuccess(response));
    }

    yield setTimeout(() => {
      const isAccountant = hasRolePermission(7);
      if (isAccountant) {
        history("/timesheets");
      } else {
        history("/dashboard");
      }
    }, [100]);
  } catch (error) {
    yield put(apiError("Invalid email/password"));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    const response = yield call(postJwtLogout, {
      email: JSON.parse(secureLocalStorage.getItem("email")),
    });

    clearLocalStorage();

    yield put(logoutUserSuccess());

    setTimeout(() => {
      history("/login");
    }, [100]);
  } catch (error) {
    alert(error?.message?.toString());
    yield put(apiError(error?.message?.toString()));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
